import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-dialogbubble', 'open', 'Chat with us');
